import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

const Footer = () => {
  return (
    <footer className="cyber-footer py-12 px-4" data-testid="site-footer">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold neon-text mb-4">CIMM Computers</h3>
            <p className="text-gray-400 mb-4">Професійний ремонт ноутбуків, телефонів та ігрових приставок в Одесі</p>
            <p className="text-gray-400 text-sm mb-4">
              Незалежний сервісний центр з постгарантійного обслуговування техніки.
              Безкоштовна діагностика, оригінальні запчастини, офіційна гарантія на роботи.
            </p>
            <SocialLinks iconSize="w-5 h-5" />
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Послуги</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/laptops" className="hover:text-orange-500 transition-colors">Ремонт ноутбуків</Link></li>
              <li><Link to="/remont-iphone" className="hover:text-orange-500 transition-colors">Ремонт iPhone (АКБ / дисплей)</Link></li>
              <li><Link to="/chistka-macbook" className="hover:text-orange-500 transition-colors">Чистка MacBook</Link></li>
              <li><Link to="/phones" className="hover:text-orange-500 transition-colors">Ремонт телефонів</Link></li>
              <li><Link to="/chistka-noutbukiv" className="hover:text-orange-500 transition-colors">Чистка ноутбуків</Link></li>
              <li><Link to="/chistka-pk" className="hover:text-orange-500 transition-colors">Чистка комп'ютерів</Link></li>
              <li><Link to="/chistka-konsoley" className="hover:text-orange-500 transition-colors">Чистка PS5 / PS4 / Xbox</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Інформація</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/contacts" className="hover:text-orange-500 transition-colors">Контакти</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-orange-500 transition-colors">Політика конфіденційності</Link></li>
              <li><Link to="/terms" className="hover:text-orange-500 transition-colors">Умови користування</Link></li>
              <li><Link to="/cookies" className="hover:text-orange-500 transition-colors">Політика cookies</Link></li>
              <li><Link to="/garantiya" className="hover:text-orange-500 transition-colors">Гарантія та повернення</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Контакти</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a href="tel:+380974178788" className="hover:text-orange-500 transition-colors" data-testid="footer-phone-link">
                  +38 097 417 8788
                </a>
              </li>
              <li>
                <a href="mailto:info@cimm.od.ua" className="hover:text-orange-500 transition-colors">
                  info@cimm.od.ua
                </a>
              </li>
              <li>м. Одеса</li>
              <li>Пн-Сб: 11:00 – 18:00</li>
              <li>Нд: вихідний</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-orange-500/20 pt-8 space-y-3 text-center text-gray-400">
          <p className="text-sm">© {new Date().getFullYear()} CIMM Computers · Всі права захищені</p>
          <p className="text-xs text-gray-500 max-w-4xl mx-auto leading-relaxed" data-testid="footer-legal-entity">
            ФОП Войчук Дмитро Володимирович · м. Одеса, Україна ·
            {' '}<a href="tel:+380974178788" className="hover:text-orange-500 transition-colors">+38 097 417 8788</a>
          </p>
          <p className="text-xs text-gray-500 max-w-4xl mx-auto leading-relaxed">
            Незалежний сервісний центр з постгарантійного обслуговування. Ми не є офіційним (авторизованим) сервісним центром
            і не пов'язані з виробниками техніки (Apple, Samsung, Sony, Microsoft, Xiaomi та ін.). Усі назви брендів,
            торгові марки та логотипи належать їхнім власникам і використовуються виключно для ідентифікації послуг.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
